import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import getIsMobile from 'store/app/selector/isMobile';
import { BsX } from 'react-icons/bs';
import styles from './Drawer.module.scss';

interface Props {
  children: React.ReactNode;
  contentClassName?: string;
  closeIconInContent?: boolean;
  onClose?: () => void;
}

const Drawer = ({ children, onClose, contentClassName, closeIconInContent }: Props) => {
  const isMobile = useSelector(getIsMobile);

  const closeClick = () => {
    if (onClose) onClose();
  };

  return (
    <div
      className={cn(styles.drawer, {
        [styles.mobile]: isMobile,
      })}
    >
      <div className={cn(styles.drawerContent, { [`${contentClassName}`]: contentClassName })}>
        {closeIconInContent && (
          <div className={cn(styles.iconInContent, styles.x)} onClick={closeClick}>
            <BsX />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Drawer;
